let config = null;

export const loadConfig = async () => {

    console.log('Loading config...');

    const response = await fetch('/config.json', {
        cache: 'no-store'
    });

    console.log('config response:', response.status);

    if (!response.ok) {
        throw new Error(`Cannot load config.json: ${response.status}`);
    }

    config = await response.json();

    console.log('config loaded:', config);

    return config;
};

export const getConfig = () => {

    if (!config) {
        throw new Error('Config has not been loaded');
    }

    return config;
};